module.exports = __webpack_public_path__ + "static/media/org-delete.501146bf.svg";